import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@chakra-ui/react';
import useResizeObserver from 'use-resize-observer';

const LimitAspectRatio = ({ children, minRatio, maxRatio }) => {
  const [xPadding, setXPadding] = useState(0);
  const [yPadding, setYPadding] = useState(100);
  const boxRef = useRef();

  const onResize = useCallback(() => {
    const box = boxRef.current;
    if (!box) {
      return;
    }
    const { offsetWidth, offsetHeight } = box;
    const aspectRatio = offsetWidth / offsetHeight;
    if (aspectRatio < minRatio) {
      const desiredHeight = offsetWidth / minRatio;
      setXPadding(0);
      setYPadding((offsetHeight - desiredHeight) / 2);
    } else if (aspectRatio > maxRatio) {
      const desiredWidth = offsetHeight * maxRatio;
      setXPadding((offsetWidth - desiredWidth) / 2);
      setYPadding(0);
    } else {
      setXPadding(0);
      setYPadding(0);
    }
  }, [minRatio, maxRatio]);
  useResizeObserver({ ref: boxRef, onResize });

  return (
    <Flex
      ref={boxRef}
      px={xPadding + 'px'}
      py={yPadding + 'px'}
      sx={{ '& > div': { flexGrow: 1 } }}
    >
      {children}
    </Flex>
  );
};

LimitAspectRatio.propTypes = {
  minRatio: PropTypes.number,
  maxRatio: PropTypes.number,
  children: PropTypes.node.isRequired,
};

LimitAspectRatio.defaultProps = {
  minRatio: 1.0,
  maxRatio: 16 / 9,
};

export default LimitAspectRatio;
